import module from 'module';

module.directive('greaterThan', function() {
  return {
    scope: {
      compareValue: '<greaterThan'
    },
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attributes, ngModel) {
      if (!ngModel) return;

      // Watch for changes in the model value
      scope.$watch(function() {
        return ngModel.$viewValue;
      }, function() {
        validate();
      });

      // Watch for changes in the compare value
      scope.$watch('compareValue', function() {
        validate();
      });

      function validate() {
        let viewValue = ngModel.$viewValue;
        let compareValue = scope.compareValue;

        // Validation logic: viewValue should be greater than compareValue
        // Both values should be present and valid numbers
        let isValid = true;
        
        if (viewValue !== undefined && viewValue !== null &&
            compareValue !== undefined && compareValue !== null) {
          // Convert to numbers for comparison
          let viewValueNum = parseFloat(viewValue);
          let compareValueNum = parseFloat(compareValue);
          
          // Check if both are valid numbers and viewValue > compareValue
          if (!isNaN(viewValueNum) && !isNaN(compareValueNum)) {
            isValid = viewValueNum > compareValueNum;
          }
        }

        ngModel.$setValidity('greaterThan', isValid);
      }
    }
  };
});